var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilePng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#CE783E",
    points: "44,27 4,27 1,23 5,19 43,19 47,23 "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA9860",
    d: "M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.414,30.645c0,0.878-0.259,1.556-0.775,2.033c-0.518,0.479-1.253,0.717-2.205,0.717h-0.597V36h-2.122 v-7.853h2.719c0.991,0,1.736,0.217,2.234,0.649C18.165,29.23,18.414,29.847,18.414,30.645z M14.837,31.666h0.387 c0.319,0,0.571-0.09,0.761-0.27c0.188-0.179,0.281-0.426,0.281-0.74c0-0.53-0.293-0.795-0.881-0.795h-0.548V31.666z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.143,36h-2.783l-2.867-5.532h-0.049c0.068,0.87,0.102,1.534,0.102,1.993V36h-1.879v-7.853h2.771 l2.857,5.457h0.031c-0.05-0.791-0.074-1.427-0.074-1.907v-3.55h1.891V36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.992,31.402h3.389v4.232c-0.92,0.315-1.932,0.473-3.034,0.473c-1.21,0-2.146-0.351-2.806-1.053 c-0.662-0.702-0.992-1.703-0.992-3.002c0-1.268,0.362-2.255,1.086-2.96c0.723-0.705,1.736-1.058,3.039-1.058 c0.494,0,0.961,0.046,1.4,0.139c0.438,0.094,0.82,0.212,1.146,0.355l-0.672,1.664c-0.566-0.279-1.188-0.418-1.863-0.418 c-0.62,0-1.1,0.201-1.438,0.604c-0.338,0.403-0.508,0.979-0.508,1.727c0,0.734,0.154,1.294,0.459,1.679 c0.307,0.385,0.748,0.577,1.324,0.577c0.315,0,0.605-0.03,0.871-0.091v-1.229h-1.402V31.402z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePng);
export default __webpack_public_path__ + "static/media/icon-file-png.31e4166f0c8eed9148e1ab44219c54e8.svg";
export { ForwardRef as ReactComponent };